import { DateFormatType } from '../types';
import { DateFormatTypeEnum } from '../enums';
import { FunctionComponent } from 'react';
import { format } from 'date-fns';

// Component
const DateFormat: FunctionComponent<DateFormatType> = ({ originalDate, formatType }) => {
  switch (formatType) {
    case DateFormatTypeEnum.DATE:
      return <>{format(new Date(originalDate), 'dd/MM/yyyy')}</>;
    case DateFormatTypeEnum.DATETIME:
      return <>{format(new Date(originalDate), "dd/MM/yyyy 'às' HH:mm")}</>;
    default:
      return <>{''}</>;
  }
};

export default DateFormat;
